export default "__VITE_PUBLIC_ASSET__d6945b69__"